import { useSelector } from "react-redux";
import { invalidSelectionText } from "../store/orderingSlice";

export function InvalidSVG({ show = false }) {
  const invalid_selection_text = useSelector(invalidSelectionText);

  return show ? (
    <svg className="invalid-strike" role="img" aria-label={invalid_selection_text}>
      <line x1="100%" y1="100%" x2="0" y2="0"></line>
    </svg>
  ) : (
    <></>
  );
}
